import script from "./IconBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./IconBlock.vue?vue&type=script&setup=true&lang=js"

import "./IconBlock.vue?vue&type=style&index=0&id=59f57fb3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f57fb3"]])

export default __exports__